import { jsx as _jsx } from "react/jsx-runtime";
import NoPartnerSelectedBookConsult from './book-consult';
const NoPartnerSelectedFlow = ({ handleClose }) => {
    return _jsx(NoPartnerSelectedBookConsult, { handleClose: handleClose });
};
export default NoPartnerSelectedFlow;
